import React from 'react'
import { HeroSection } from "../component/Features/HeroSection"
// import Navbar from '../component/Navbar/navbar'
import HeaderMenu from '../component/Navbar/headermenu'
import { Slider } from '../component/Features/Slider'
import { FeatureSection } from "../component/Features/FeaturesCard"
import { GridFeaturesSection } from '../component/Features/GridFeaturesSection'
import { SpotLight } from '../component/Features/SpotLight'
import { FinalCTA } from '../component/Features/FinalCTA'
import CustomFooter from '../component/Footer/customFooter'
export function Features() {
    return (
        <div>
            {/* <Navbar /> */}
            <HeaderMenu />
            <HeroSection />
            <Slider />
            {/* <FeaturesCard /> */}
            <FeatureSection
                title="See Everything. Miss Nothing."
                description="Your dashboard shows exactly what needs attention right now."
                features={[
                    'Real-time dashboard with intelligent prioritization',
                    'Urgent tasks pulse gently to catch your eye',
                    'All notifications unified in one clean hub',
                    'Role-specific views that adapt to your needs',
                ]}
                mockupType="dashboard"
                reversed={false}
                metric={{
                    before: "3 hrs",
                    after: "15 min",
                    label: "Average response time",
                }}
            />
            <FeatureSection
                title="Work Flows. Nothing Sticks."
                description="Tasks move through your workflow automatically. Progress is visible. Bottlenecks are obvious. Work simply gets done."
                features={[
                    'Visual workflow with automatic stage transitions',
                    'Smart reminders before deadlines approach',
                    'Close any task in 5 clicks or less',
                    'Progress tracking that updates in real-time',
                ]}
                mockupType="workflow"
                reversed={true}
                metric={{
                    before: '8 clicks',
                    after: '2 clicks',
                    label: 'To complete a task',
                }}
            />
            <FeatureSection
                title="Everyone Knows Their Part."
                description="Admins see billing. Managers approve work. Members execute. Clients stay informed. No confusion. No training required."
                features={[
                    'Four distinct role views with perfect permissions',
                    'Interface automatically adapts to your role',
                    'Clients get view-only access to shared work',
                    'Zero learning curve for new team members',
                ]}
                mockupType="roles"
                reversed={false}
                metric={{
                    before: '2 days',
                    after: '0 min',
                    label: 'Training time needed',
                }}
            />
            <GridFeaturesSection />
            <SpotLight />
            <FinalCTA />
            <CustomFooter />
        </div>
    )
}
